
export const urlSourceList = '/XOrg/PartnerCourseWare/getSourceList';
export const urlSaveFolder = '/XOrg/PartnerCourseWare/saveFolder';
export const urlsaveUrlSource = '/XOrg/PartnerCourseWare/saveUrlSource';
import http from 'lib/http';
import { RequestResult } from '../design/v1.design.courseteacher';
export const urldelCourseWare = '/XOrg/PartnerCourseWare/delCourseWare';
export const urlupdateCourseWare = '/XOrg/PartnerCourseWare/updateCourseWare';
export const urldelallCourseWare = '/XOrg/PartnerCourseWare/delallCourseWare';
export const urlmoveFolder = '/XOrg/PartnerCourseWare/moveFolder';
export const urlgetFolderId = '/XOrg/PartnerCourseWare/getFolderId';
export const urlgetSchoolManageFolderList = '/XOrg/PartnerCourseWare/getSchoolManageFolderList';
export const urlgetStuList = '/XOrg/CourseClass/getClassStu';
export const urlgetSchoolList = '/XOrg/PartnerShareSource/getSchool';
export const urlgetSchoolIdList = '/XOrg/PartnerShareSource/GetSchoolIdList';
export const urlgetTeaList = '/XOrg/PartnerShareSource/GetSchoolCourseSourceTeaList';
export const urlGetPartnerCourseType = '/XOrg/PartnerShareSource/GetPartnerCourseType';
export const urlgetimpoweschoollist = '/XOrg/PartnerShareSource/GetImpowerSchoolList';
export const urlgetnotimpoweschoollist = '/XOrg/PartnerShareSource/GetNotImpowerSchoolList';
export const urlGetCourseBySchool = '/XOrg/PartnerShareSource/GetCourseBySchool';
export const urlgetallimpowerschoollist = '/XOrg/PartnerShareSource/GetAllImpowerSchoolList';
export const urlGetTeacherIsAuthentication = '/XOrg/PartnerCourseWare/GetTeacherIsAuthentication';
export const urlUpdateCourse = '/XOrg/PartnerCourseWare/UpdateCourse';
export const urlschoolAddLabels = '/XOrg/PartnerCourseWare/schoolAddLabels';
export const urlupdateVerify = '/XOrg/PartnerCourseWare/updateVerify';

export function updateVerify(ids: string[],state:number) {
  return http.post<updateISource>(urlupdateVerify, {
    ids,
    state
  });
}


export interface ISourceList {
  code: number;
  list: {
    /* Name */
    CourseWareName: string;
    CourseWareType: string;
    CreateUserId: string;
    DateCreated: string;
    DocExtension: string;
    DocSize: string;
    DocUrl: string;
    DocPrexUrl: string;
    Id: string;
    Keyword: {}[];
    MediaType: number;
    Language: string;
    Source: string;
    Author: string;
    Company: string;
    ContactInformation: string;
  }[];
  msg: string;
  FolderId: string;
  pagination: {
    pageIndex: number;
    pageSize: number;
    totalCount: number;
  };
  courseId: string;
  courseName: string;
  nodePathList: {
    Id: string,
    nodeName: string
  }[];
  dataCount: number;
}

export function moveFolder(ids: string[], fId: string) {
       return http.post<ISourceList>(urlmoveFolder, {
         ids,
         fId
       });
}

export interface updateISource {
  code: number;
  msg: string;
}

export function UpdateCourse(sourceId: string[]) {
  return http.post<updateISource>(urlUpdateCourse, {
    sourceId
  });
}

export interface IFolder {
  code: number;
  list: {
    Id: string;
    ParentId: string;
    NodePath: string;
    FolderName: string;
  }[];
}

export function getFolderId() {
  return http.post<IFolder>(urlgetFolderId, {
  }).then((rst) => {
    let folder = {};
    let resultFolder = <any>[];
    if (rst.list && rst.list.length) {

      folder = {};
      rst.list.forEach(el => {
        // el.NodePath
        if (el.ParentId === '0') {
          folder[el.Id] = folder[el.Id] || {
            id: el.Id,
            children: []
          };
          folder[el.Id]['label'] = el.FolderName;
          resultFolder.push(folder[el.Id]);
        } else {
          if (el.NodePath && el.NodePath.length) {
            let paths = el.NodePath.split('/');
            let pathsLen = paths.length - 1;
            for (let i = 0; i <= pathsLen; i++) {
              let path = paths[i];

              if (i !== pathsLen) {
                folder[path] = folder[path] || {
                  id: path,
                  children: []
                };
              } else {
                folder[path] = folder[path] || {
                  id: el.Id
                };
                folder[path]['label'] = el.FolderName;

                let parent = folder[el.ParentId];
                if (parent && !parent.children) {
                  parent['children'] = [];
                }
                folder[el.ParentId].children.push(folder[path]);
              }
              folder[el.ParentId] = folder[el.ParentId] || {
                id: el.ParentId,
                children: []
              };
            }
          }
        }
      });
    }
    return resultFolder;
  });
}
// 学校管理员获取文件夹列表
export function getSchoolManageFolderList(schoolCourseId:string,courseId:string) {
  return http.post<IFolder>(urlgetSchoolManageFolderList, {
    schoolCourseId,
    courseId
  }).then((rst) => {
    let folder = {};
    let resultFolder = <any>[];
    if (rst.list && rst.list.length) {
      folder = {};
      rst.list.forEach(el => {
        // el.NodePath
        if (el.ParentId === '0') {
          folder[el.Id] = folder[el.Id] || {
            id: el.Id,
            children: []
          };
          folder[el.Id]['label'] = el.FolderName;
          resultFolder.push(folder[el.Id]);
        } else {
          if (el.NodePath && el.NodePath.length) {
            let paths = el.NodePath.split('/');
            let pathsLen = paths.length - 1;
            for (let i = 0; i <= pathsLen; i++) {
              let path = paths[i];
              if (i !== pathsLen) {
                folder[path] = folder[path] || {
                  id: path,
                  children: []
                };
              } else {
                folder[path] = folder[path] || {
                  id: el.Id
                };
                folder[path]['label'] = el.FolderName;

                let parent = folder[el.ParentId];
                if (parent && !parent.children) {
                  parent['children'] = [];
                }
                folder[el.ParentId].children.push(folder[path]);
              }
              folder[el.ParentId] = folder[el.ParentId] || {
                id: el.ParentId,
                children: []
              };
            }
          }
        }
      });
    }
    return resultFolder;
  });
}

export function GetSourceList(
  IsPartner: string,
  sort: string,
  folderId?: string,
  type?: string,
  page?: number,
  SchoolCourseTypeId?: string,
  pageSize?: number,
  courseId?:string
) {
  return http.get<ISourceList>(urlSourceList, {
    params: {
      IsPartner,
      sort,
      folderId,
      type,
      page,
      SchoolCourseTypeId,
      pageSize,
      courseId
    }
  });
}

export interface CourseWareInfo {
  code: number;
  status: number;
  docPriviewUrl: string;
  docType: number;
  docName: string;
  type: string;
}
export const urlSourceInfo = '/XOrg/PartnerCourseWare/getCourseWareInfo';
export function GetSourceInfo(coursewareid: string) {
  return http.get<CourseWareInfo>(urlSourceInfo, {
    params: {
      coursewareid
    }
  });
}

export function saveFolder(folderName: string, folderId: String, SchoolCourseTypeId: String, IsPartner: string,courseId:string) {
  return http.post<RequestResult>(urlSaveFolder, {
    folderName: folderName,
    folderId: folderId ,
    SchoolCourseTypeId: SchoolCourseTypeId,
    IsPartner: IsPartner,
    courseId:courseId
  });
}

export function saveUrlSource(DocPrviewUrl: string, sourceName: string, folderId: string, CourseId?: string, IsPartner?: string, SchoolCourseTypeId?: String) {
  return http.post<RequestResult>(urlsaveUrlSource, {
    DocPrviewUrl: DocPrviewUrl,
    CourseWareName: sourceName,
    FolderId: folderId,
    CourseId: CourseId,
    IsPartner: IsPartner,
    SchoolCourseTypeId: SchoolCourseTypeId
  });
}

export function UpdateCourseWare(Id: string, CourseWareName: string, txtsourceUrl: string) {
  return http.get<ISourceList>(urlupdateCourseWare, {
    params: {
      Id,
      CourseWareName,
      txtsourceUrl
    }
  });
}

export function DelCourseWare(Id: string) {
  return http.post<ISourceList>(urldelCourseWare, {
    Id
  });
}

export function delallCourseWare(ids: string[]) {
      return http.post<ISourceList>(urldelallCourseWare, {
        ids
      });
}

export interface stuList {
  stuList: String;
}

export function getStuList(classId: string) {
  return http.post<stuList>(urlgetStuList, {
    classId
  });
}

export interface SchoolList {
  code: String;
  list: {
    Id: string,
    SchoolName: string,
    SchoolLogoUrl: string,
    SchoolProvince: string
  };
  pagination: {
    totalCount: number,
    pageSize: number,
    pageIndex: number
  };
}

/// 获取学校列表
export function getSchoolList(schoolName: string, page?: number) {
  return http.post<SchoolList>(urlgetSchoolList, {
    schoolName,
    page
  });
}

export interface SchoolIdList {
  code: String;
  msg: string;
  SchoolList: {
    CreatedSchoolId: string,
    CreatedSchoolName: string
  }[];
}

/// 获取已授权的学校
export function GetSchoolIdList() {
  return http.post<SchoolIdList>(urlgetSchoolIdList, {
  });
}

export interface SchoolCourseType {
  code: String;
  msg: string;
  list: {
    Title: string,
    Code: string,
    Id: string,
    Cover: string
  };
}

/// 获取合作伙伴学校课程类型
export function GetPartnerCourseType(SchoolId: string,MajorId:string) {
  return http.post<SchoolCourseType>(urlGetPartnerCourseType, {
    SchoolId,
    MajorId
  });
}

export interface teaList {
  code: String;
  teaList: {
    CreateUserId: string,
    CreateDisplayName: string,
    CreateAvatorUrl: string
  };
}

export function GetSchoolCourseSourceTeaList(SchoolCourseTypeId?: string) {
  return http.post<teaList>(urlgetTeaList, {
    SchoolCourseTypeId
  });
}

export interface CourseInfo {
  code: String;
  list: {
    Id: string,
    DateCreated: string,
    CreateDisplayName: string,
    CreateUserCover: string,
    Title: string,
    Cover: string,
    Description: string
  };
  pagination: {
    totalCount: number,
    pageSize: number,
    pageIndex: number
  };
}

export function GetCourseBySchool(SchoolCourseTypeId: string, Title: string, page?: number) {
  return http.post<CourseInfo>(urlGetCourseBySchool, {
    SchoolCourseTypeId,
    Title,
    page
  });
}

export interface SchoolInfo {
  code: String;
  list: {
    Id: string,
    SchoolName: string,
    SchoolLogoUrl: string,
    SchoolProvince: string
  };
  pagination: {
    totalCount: number,
    pageSize: number,
    pageIndex: number
  };
}

export function GetImpowerSchoolList(SchoolCourseId: string, schoolName: string, page?: number, pageSize?: number) {
  return http.post<SchoolInfo>(urlgetimpoweschoollist, {
    SchoolCourseId,
    schoolName,
    page,
    pageSize
  });
}

export function GetNotImpowerSchoolList(impschoolName: string,type:number, page?: number, pageSize?: number) {
  return http.post<SchoolInfo>(urlgetnotimpoweschoollist, {
    impschoolName,
    type,
    page,
    pageSize
  });
}

/// 获取学校所有已授权的学校
export function GetAllImpowerSchoolList(schoolName: string, page?: number, pageSize?: number) {
  return http.post<SchoolInfo>(urlgetallimpowerschoollist, {
    schoolName,
    page,
    pageSize
  });
}

export interface teacherInfo {
  code: String;
  IsAuthentication: number;
}

/// 获取学校所有已授权的学校
export function GetTeacherIsAuthentication() {
  return http.post<teacherInfo>(urlGetTeacherIsAuthentication, {
  });
}

export function schoolAddLabels(
  id: string,
  keyword: string,
  mediaType: number,
  language: number,
  sourceone: number,
  author: string,
  company: string,
  contactInformation: string
) {
  return http.post<updateISource>(urlschoolAddLabels, {
    id,
    keyword,
    mediaType,
    language,
    sourceone,
    author,
    company,
    contactInformation
  });
}